export default __webpack_public_path__ + "static/media/add2.800804d4.png";